export function setLanguage(language = "en") {
	localStorage.setItem("lan", JSON.stringify(language));
}

export function getLanguage() {
	return JSON.parse(localStorage.getItem("lan"));
}
